import BaseApi from './baseApi';
import IInboundDetail from '../models/IInboundDetail';
import IAuthentication from '../models/IAuthentication';
export default class InboundDetailsApi extends BaseApi {
    idUser : string = "";
    constructor(page: string) {
        super("dataaccess", page);
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInboundDetails(idInbound: string) : Promise<IInboundDetail[]> {
        let json : string = this.getJsonRead(idInbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDetails: IInboundDetail[] = [];
            inboundDetails = response.data as IInboundDetail[];
            return inboundDetails;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundDetailById(id: string) : Promise<IInboundDetail[]> {
        let json : string = this.getJsonReadById(id);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDetails: IInboundDetail[] = [];
            inboundDetails = response.data as IInboundDetail[];
            return inboundDetails;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsDetailDeliveryNotesDetail(idInbound: string) : Promise<IInboundDetail[]> {
        let json : string = this.getJsonReadDeliveryNotesDetail(idInbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDetails: IInboundDetail[] = [];
            inboundDetails = response.data as IInboundDetail[];
            return inboundDetails;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInboundDetail(inboundDetail: IInboundDetail) : Promise<string> {
        const json = this.getJsonSave(inboundDetail);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateInboundDetail(inboundDetail: IInboundDetail) : Promise<boolean> {
        const json = this.getJsonUpdate(inboundDetail);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async UpdateInboundDetailPartial(inboundDetail: IInboundDetail) : Promise<boolean> {
        const json = this.getJsonUpdatePartial(inboundDetail);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDetailByInboundId(inboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByInboundId(inboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByInboundId(inboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDetail",
            "conditions": [{
                "Item1": "InboundsDetail",
                "Item2": "idInbound",
                "Item3": "=",
                "Item4": inboundId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDetail",
            "conditions": [{
                "Item1": "InboundsDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(inboundDetail: IInboundDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idInbound",
                "Item2": inboundDetail.idInbound
            }, {
                "Item1": "idGood",
                "Item2": inboundDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": inboundDetail.idListPallet
            }, {
                "Item1": "palletsAmount",
                "Item2": inboundDetail.palletsAmount
            }, {
                "Item1": "casesPerPallet",
                "Item2": inboundDetail.casesPerPallet
            }, {
                "Item1": "totalCases",
                "Item2": inboundDetail.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": inboundDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": inboundDetail.totalGoods
            }, {
                "Item1": "bestBeforeDate",
                "Item2": inboundDetail.bestBeforeDate
            }, {
                "Item1": "language",
                "Item2": inboundDetail.language
            }, {
                "Item1": "documentation",
                "Item2": inboundDetail.documentation
            }, {
                "Item1": "weight",
                "Item2": inboundDetail.weight
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDetail"
        };
        return json;
    }

    private getJsonUpdate(inboundDetail: IInboundDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idInbound",
                "Item2": inboundDetail.idInbound
            }, {
                "Item1": "idGood",
                "Item2": inboundDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": inboundDetail.idListPallet
            }, {
                "Item1": "palletsAmount",
                "Item2": inboundDetail.palletsAmount
            }, {
                "Item1": "casesPerPallet",
                "Item2": inboundDetail.casesPerPallet
            }, {
                "Item1": "totalCases",
                "Item2": inboundDetail.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": inboundDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": inboundDetail.totalGoods
            }, {
                "Item1": "bestBeforeDate",
                "Item2": inboundDetail.bestBeforeDate
            }, {
                "Item1": "language",
                "Item2": inboundDetail.language === null ? "" : inboundDetail.language
            }, {
                "Item1": "documentation",
                "Item2": inboundDetail.documentation === null ? false : inboundDetail.documentation
            }, {
                "Item1": "weight",
                "Item2": inboundDetail.weight
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDetail",
            "keyvalue": inboundDetail.id
        };
        return json;
    }

    private getJsonUpdatePartial(inboundDetail: IInboundDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "bestBeforeDate",
                "Item2": inboundDetail.bestBeforeDate
            }, {
                "Item1": "language",
                "Item2": inboundDetail.language === null ? "" : inboundDetail.language
            }, {
                "Item1": "documentation",
                "Item2": inboundDetail.documentation === null ? false : inboundDetail.documentation
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDetail",
            "keyvalue": inboundDetail.id
        };
        return json;
    }

    private getJsonReadDeliveryNotesDetail(idInbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsDetail",
                "Item2": "id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idInbound"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "Name as goodName"
            }, {
                "Item1": "Goods",
                "Item2": "sku as sku"
            }, {
                "Item1": "Goods",
                "Item2": "Code as goodCode"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListPalletTypes where id = IdListPallet) as palletName"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "PalletsAmount - ISNULL((SELECT SUM(PalletsAmount) FROM InboundsDeliveryNotesDetail WHERE IdInboundDetail = InboundsDetail.Id AND InboundsDetail.Deleted = 0 AND InboundsDeliveryNotesDetail.Deleted = 0), 0) AS PalletsAmount"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "TotalCases - ISNULL((SELECT SUM(TotalCases) FROM InboundsDeliveryNotesDetail WHERE IdInboundDetail = InboundsDetail.Id  AND InboundsDetail.Deleted = 0 AND InboundsDeliveryNotesDetail.Deleted = 0), 0) AS TotalCases"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "TotalGoods - ISNULL((SELECT SUM(TotalGoods) FROM InboundsDeliveryNotesDetail WHERE IdInboundDetail = InboundsDetail.Id  AND InboundsDetail.Deleted = 0 AND InboundsDeliveryNotesDetail.Deleted = 0), 0) AS TotalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "weight"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT COUNT(StockDetail.Id) FROM InboundsDeliveryNotesDetail LEFT OUTER JOIN StockDetail ON (InboundsDeliveryNotesDetail.Id = StockDetail.IdInboundDeliveryNoteDetail)WHERE IdInboundDetail = InboundsDetail.Id AND Deleted = 0), 0) AS InDeliveryNote"
            }],
            "tables": [{
                "Item1": "InboundsDetail"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "Goods"
            }],
            "joins": [{
                "Item1": "InboundsDetail",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idGood",
                "Item3": "Goods",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "=",
                "Item4": idInbound,
                "Item5": "AND"
            },
            {
                "Item1": "InboundsDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }

    private getJsonRead(idInbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsDetail",
                "Item2": "id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idInbound"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "Name as goodName"
            }, {
                "Item1": "Goods",
                "Item2": "Code as goodCode"
            }, {
                "Item1": "Goods",
                "Item2": "sku as sku"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListPalletTypes where id = InboundsDetail.IdListPallet) as palletName"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "palletsAmount"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "totalCases"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT SUM(CasesPerPallet) FROM InboundsNoticeOfLossDetail WHERE IdInboundDeliveryNoteDetail IN (SELECT Id FROM InboundsDeliveryNotesDetail WHERE IdInboundDetail = InboundsDetail.Id) AND Deleted = 0), 0)  AS CasesLoss"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "weight"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT SUM(dnd.totalcases) FROM InboundsDeliveryNotesDetail dnd INNER JOIN InboundsDetail idt ON idt.Id = dnd.IdInboundDetail WHERE idt.Id = InboundsDetail.Id AND dnd.Deleted = 0), 0) AS InDeliveryNote"
            }],
            "tables": [{
                "Item1": "InboundsDetail"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "Goods"
            }],
            "joins": [{
                "Item1": "InboundsDetail",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idGood",
                "Item3": "Goods",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "=",
                "Item4": idInbound
            }]
        };
        return json;
    }

    private getJsonReadById(id: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsDetail",
                "Item2": "id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idInbound"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "Name as goodName"
            }, {
                "Item1": "Goods",
                "Item2": "sku as sku"
            }, {
                "Item1": "Goods",
                "Item2": "Code as goodCode"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListPalletTypes where id = InboundsDetail.IdListPallet) as palletName"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "palletsAmount"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "totalCases"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT SUM(CasesPerPallet) FROM InboundsNoticeOfLossDetail WHERE IdInboundDeliveryNoteDetail IN (SELECT Id FROM InboundsDeliveryNotesDetail WHERE IdInboundDetail = InboundsDetail.Id) AND Deleted = 0), 0)  AS CasesLoss"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "weight"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT SUM(dnd.totalcases) FROM InboundsDeliveryNotesDetail dnd INNER JOIN InboundsDetail idt ON idt.Id = dnd.IdInboundDetail WHERE idt.Id = InboundsDetail.Id AND dnd.Deleted = 0), 0) AS InDeliveryNote"
            }],
            "tables": [{
                "Item1": "InboundsDetail"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "Goods"
            }],
            "joins": [{
                "Item1": "InboundsDetail",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "idGood",
                "Item3": "Goods",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "Id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }
}
